import React from 'react';
import { Modal } from 'react-bootstrap';
import VendorCreateScreen from '../../../screens/VendorCreateScreen';

const VendorModal = ({ show, handleClose, handleVendorCreated }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Create New Vendor</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <VendorCreateScreen 
                    onVendorCreated={handleVendorCreated}
                    onCancel={handleClose}
                    embedded={true}
                />
            </Modal.Body>
        </Modal>
    );
};

export default VendorModal; 